var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "auto", margin: "15px 25px 15px 25px" } },
    [
      _c("br"),
      _vm._v(" "),
      _c("h1", { staticClass: "pb-2 border-bottom" }, [
        _vm._v("mKOLON4 관리자 앱 (" + _vm._s(_vm.plfTpNm) + ")")
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "list-group w-auto" },
        [
          _vm._l(_vm.appList, function(item, index) {
            return [
              _c(
                "a",
                {
                  staticClass:
                    "list-group-item list-group-item-action d-flex gap-3 py-3",
                  attrs: {
                    href: _vm.installUrl("" + item.appId),
                    "aria-current": "true"
                  }
                },
                [
                  _c("img", {
                    staticClass: "rounded-circle flex-shrink-0",
                    attrs: { src: "" + item.iconUrl, width: "50", height: "50" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex gap-2 w-100 justify-content-between"
                    },
                    [
                      _c("div", [
                        _c("h2", { staticClass: "mb-1" }, [
                          _vm._v(_vm._s(item.appNm))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "mb-1 opacity-75" }, [
                          _vm._v(
                            "[" +
                              _vm._s(item.versionNm) +
                              "] " +
                              _vm._s(item.versionDesc)
                          )
                        ])
                      ])
                    ]
                  )
                ]
              )
            ]
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33a216a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a216a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Apps.vue
// module id = null
// module chunks = 